// extracted by mini-css-extract-plugin
export default {"cardScheme":"FtV7__RdslQLgpchIOH6"};